/**
 * Chart color palette and theme constants derived from Kyndryl brand.
 * Used by all visx chart components for consistent styling.
 */

/** Series colors — 6 distinguishable hues from Kyndryl palette */
export const SERIES_COLORS = [
  '#4CDD84', // Spring Green
  '#29707A', // Spruce
  '#FF462D', // Warm Red
  '#9E9287', // Earth
  '#187E3F', // Digital Dark Spring Green
  '#565049', // Digital Dark Earth
];

/** Get a color for a series index, cycling through the palette */
export function seriesColor(index: number): string {
  return SERIES_COLORS[index % SERIES_COLORS.length];
}

/** Grid and axis colors for dark and light themes */
export const CHART_THEME = {
  dark: {
    gridColor: 'rgba(242, 241, 238, 0.08)',
    axisColor: 'rgba(242, 241, 238, 0.3)',
    tickLabelColor: '#A8A29D',
    crosshairColor: 'rgba(242, 241, 238, 0.4)',
    tooltipBg: '#1A1F1D',
    tooltipBorder: '#2A2F2D',
    tooltipText: '#F2F1EE',
    cardBg: '#0A0F0D',
  },
  light: {
    gridColor: 'rgba(0, 0, 0, 0.08)',
    axisColor: 'rgba(0, 0, 0, 0.3)',
    tickLabelColor: '#3D3C3C',
    crosshairColor: 'rgba(0, 0, 0, 0.3)',
    tooltipBg: '#FFFFFF',
    tooltipBorder: '#E0E0E0',
    tooltipText: '#3D3C3C',
    cardBg: '#FFFFFF',
  },
} as const;

export type ChartThemeMode = keyof typeof CHART_THEME;
